export default __webpack_public_path__ + "static/media/logo-white.a77cdcdf.svg";